<template>
    <div class="mb-3">
        <b-card no-body>
            <b-card-header class="p-1 pl-3">
                <b-row>
                    <b-col cols="auto">
                        <h4>{{ title }}</h4>
                    </b-col>
                    <b-col cols="auto" class="ml-auto">
                        <slot name="header" />
                        <b-button-group size="sm">
                            <b-button variant="dark" @click="load()">
                                Refresh
                            </b-button>
                            <b-button
                                v-if="write"
                                variant="success"
                                @click="show = true"
                            >
                                {{ write }}
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body v-if="ready" class="p-2 p-sm-3">
                <slot />
            </b-card-body>
            <b-card-body v-else>
                <Spinner text="Loading" />
            </b-card-body>
        </b-card>
        <b-modal v-model="show" :title="write">
            <Spinner v-if="writing" text="Saving" />
            <slot v-else name="modal" />
            <template v-slot:modal-footer="{ close }">
                <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="
                        close()
                        show = false
                    "
                >
                    Cancel
                </b-button>
                <b-button
                    size="sm"
                    variant="success"
                    @click="
                        add()
                            .then(() => close())
                            .catch(() => null)
                    "
                >
                    {{ write }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Spinner from '@/components/general/spinner'

    export default {
        props: ['title', 'write'],
        data() {
            return {
                show: false,
                ready: false,
                writing: false
            }
        },
        methods: {
            async load() {
                this.ready = false
                await this.$listeners.read()
                this.ready = true
            },
            async add() {
                this.writing = true
                return this.$listeners
                    .write()
                    .catch(error => {
                        this.$bvToast.toast(error, {
                            title: 'Error',
                            variant: 'warning'
                        })
                        throw error
                    })
                    .finally(() => (this.writing = false))
            }
        },
        created() {
            this.load()
        },
        components: {
            Spinner
        }
    }
</script>

<style scoped>
</style>